<template>
  <BaseNew @new-confirm-action="createEntry" @new-cancel-action="resetForm" @new-open-action="loadServerEntry"
    @clear-form-errors="clearFormErrors" ref="baseNew" width="70%" :formErrors="formErrors" :loading="loading"
    :pageLoading="pageLoading" :modelNameSingular="modelNameSingular"
    @new-confirm-and-add-other-action="createEntry(true)" :saveAndAddOtherButtonEnabled="true">
    <template slot="newForm">
      <v-col cols="12" sm="6">
        <v-file-input label="Selecionar nota" variant="underlined" v-model="file"></v-file-input>
      </v-col>


      <Form
        ref="form"
        :entry="entry"
        :extraData="extraData"
        :modelNameSingular="modelNameSingular"
        v-if="entryLoaded"
      />
      
    
    </template>

  </BaseNew>
</template>

<script>
import gql from 'graphql-tag';
import Form from "./form.vue";
import BaseNew from "@shared_components/base_new.vue";

export default {
  data() {
    return {
      error: null,
      loading: false,
      pageLoading: false,
      entry: {},
      formErrors: [],
      extraData: null,
      entryLoaded: false,
      file: null,
    };
  },
  props: {
    modelNameSingular: {
      type: String,
      default() {
        return "Importar Compra";
      },
    },
  },
  components: {
    BaseNew: BaseNew,
    Form: Form, 
  },
  watch: {
    "file": function () {
      // console.log("Alterou entry.periodIdsAttribute", this.entry.periodIdsAttribute)
      console.log("file", this.file);
      this.entry = {};
      this.entry.file = "";
      // for (let index = 0; index < this.files.length; index++) {
        const element = this.file;
        var reader = new FileReader();
        var self = this;
        // console.log("self", self);
        reader.readAsDataURL(element);
        reader.onload = function () {
          // console.log(reader.result);
          console.log("selfentry", self.entry);
          const data = reader.result;
          self.entry.file = element.name+";"+data;
          console.log("all", self.entry);
          self.loadServerEntry();
        };
      // }
    },
  },
  methods: {
    loadServerEntry: function () {
      this.pageLoading = true;
      this.$apollo
        .query({
          query: IMPORT_PURCHASE_MUTATION,
          fetchPolicy: "no-cache",
          variables: {
            file: this.entry.file,
          }
        })
        .then(response => {
            console.log("resp", response.data);
            this.entry = response.data.accountContext.importPurchase;
            this.extraData=response.data;
            this.entryLoaded=true;
          // var errors = response.data.createAgrotoxic.errors
          // if (errors.length) {
          //   this.formErrors = errors
          // } else {
          //   this.$refs.baseNew.closeDialog();
          //   this.$emit("entry-created", response.data.createAgrotoxic.item);
          //   if (saveAndAddOther) {
          //     this.loadServerEntry();
          //     this.$refs.baseNew.newDialog = true;
          //   }
          // }
        })
        .catch(error => {
          let { graphQLErrors, networkError, response, operation } = error;
          console.log("error", error)
          console.log("caiu no catch");
          console.log(graphQLErrors);
          console.log(networkError);
          console.log(response);
          console.log(operation);
          if (networkError) {
            console.log(`[Network error]: ${networkError}`);
          }
          else if (graphQLErrors) {
            graphQLErrors.map(({ message, locations, path }) =>
              console.log(
                `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`
              )
            );
          }
        })
        .finally(() => (this.pageLoading = false));
    },
    createServerEntry: function (agrotoxic, saveAndAddOther = false) {
      // console.log("AGROTOXIC", agrotoxic, this.entry.validations, this.deepFilterEntryWithAllowedFieldsForMutation(agrotoxic, this.entry.validations));
      this.pageLoading = true;
      this.$apollo
        .query({
          query: IMPORT_PURCHASE_MUTATION,
          fetchPolicy: "no-cache",
          variables: {
            file: this.entry.file,
          }
        })
        .then(response => {
            console.log("resp", response.data);
            this.entry = response.data.accountContext.importPurchase;
            this.extraData=response.data;
            this.entryLoaded=true;
          // var errors = response.data.createAgrotoxic.errors
          // if (errors.length) {
          //   this.formErrors = errors
          // } else {
          //   this.$refs.baseNew.closeDialog();
          //   this.$emit("entry-created", response.data.createAgrotoxic.item);
          //   if (saveAndAddOther) {
          //     this.loadServerEntry();
          //     this.$refs.baseNew.newDialog = true;
          //   }
          // }
        })
        .catch(error => {
          let { graphQLErrors, networkError, response, operation } = error;
          console.log("error", error)
          console.log("caiu no catch");
          console.log(graphQLErrors);
          console.log(networkError);
          console.log(response);
          console.log(operation);
          if (networkError) {
            console.log(`[Network error]: ${networkError}`);
          }
          else if (graphQLErrors) {
            graphQLErrors.map(({ message, locations, path }) =>
              console.log(
                `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`
              )
            );
          }
        })
        .finally(() => (this.pageLoading = false));
    },
    createEntry: function (saveAndAddOther = false) {
      // if (this.$refs.form.isFormValid()) {
        this.createServerEntry(this.entry, saveAndAddOther);
        // this.resetForm();
      // }
    },
    resetForm: function () {
      // this.$refs.form.resetFormInputs();
      // this.formErrors = [];
    },
    clearFormErrors: function () {
      // this.formErrors = [];
    }
  }
};

const IMPORT_PURCHASE_MUTATION = gql`
  query($file: String!) {
    accountContext{
      importPurchase(file: $file) {
        id
        code
        cfopId
        billDate
        series
        number
        estimatedDeliveryDate
        orderValidity
        supplierId
        customerId
        emitName
        buyerName
        totalPrice
        validations
        totalCarriageValue
        totalDiscountValue
        totalInsuranceValue
        otherExpensesTotalValue
        observation
        dummyEntryMovementItemsAttributes {
          id
          price
          quantity
          importItemName
          hasLot
          enabledLots
          itemId
          item {
            id
            name
            description
            unit {
              name
            }
          }
          dummyEntryMovementItemLotsAttributes{
            dueDate
            manufacturingDate
            lotNumber
            quantity
            packagingQuantity
          }
          packagingId
          packaging {
            id
            name
            unitName
          }
          storageId
          storage {
            id
            name
            location
          }
          validations
        }
        paymentsAttributes {
          id
          code
          bankAccountId
          paymentMethodId
          value
          initialDate
          installmentsInterval {
            id
          }
          paymentConditionId
          paymentCondition {
            id
            description
            numberOfInstallments
          }
          paymentMethod {
            id
            name
          }
          bankAccount {
            id
            name
          }
          installmentsAttributes {
            id
            value
            originalValue
            customCode
            dueDate
            code
            status
            statusKey
            statusColor
            paidAmount
            paymentDate
            bankAccount {
              id
              name
            }
          }
        } 
      }
      allSuppliers {
        id
        name
      }
      allCollaborators{
        id
        name
      }
      allPurchaseCfops{
        id
        text
      }
    }
    globalContext {
      allPaymentConditions {
        id
        description
        numberOfInstallments
      }
      allStates {
        id
        shortName
      }
    }
  }
`;

</script>

<style scoped></style>
